/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedDtmDocUpdateRequest } from '../types/PatchedDtmDocUpdate';
import type { DtmDocUpdateResponse } from '../types/DtmDocUpdate';

export type DtmDocsPartialUpdateRequest = PatchedDtmDocUpdateRequest;
export type DtmDocsPartialUpdateResponse = DtmDocUpdateResponse;

export type DtmDocsPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/dtm_docs/{id}/
 *
 * ```yaml
 * operationId: dtm_docs_partial_update
 * tags:
 *   - dtm_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmDocUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmDocUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmDocUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmDocUpdate'
 *     description: ''
 * ```
 */
export const dtmDocsPartialUpdateOperation = ({ id, ...rest }: DtmDocsPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/dtm_docs/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/dtm_docs/{id}/' };
  };

/**
 * PATCH /dmx-server/dtm_docs/{id}/
 *
 * ```yaml
 * operationId: dtm_docs_partial_update
 * tags:
 *   - dtm_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmDocUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmDocUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmDocUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmDocUpdate'
 *     description: ''
 * ```
 */
export const dtmDocsPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DtmDocsPartialUpdateQuery;
  request: PatchedDtmDocUpdateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DtmDocUpdateResponse>> => {
  const operation = dtmDocsPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
